import {AppState} from './app.state';

export const AllStates = [
  AppState,
];
